import React from 'react';
import { SimpleModal } from '../../../../components/SimpleModal';
import { ModalProps } from '../../../../components/Modal';
import { Button } from '../../../../components';

import { ReactComponent as WarningModal } from '../../../../assets/warningModal.svg';
import { WhatsappWhiteSM } from '../../../../components/Icons';

type ModalNoEligibilityProps = { callToSupport: () => void; goToHome: () => void } & Pick<
  ModalProps,
  'visible' | 'onClose'
>;

export const ModalSystemUnavailable: React.FC<ModalNoEligibilityProps> = ({
  callToSupport,
  goToHome,
  visible,
  onClose
}) => {
  return (
    <SimpleModal
      visible={visible}
      onClose={onClose}
      mainIcon={<WarningModal />}
      title="Erro ao carregar as informações"
      subtitle="Por favor aguarde alguns instantes e tente novamente. Se o problema continuar, entre em contato o nosso suporte."
      customFooterContainer={
        <>
          <Button
            disabled={!visible}
            type="button"
            title="Falar com o suporte"
            iconLeft={<WhatsappWhiteSM />}
            onClick={callToSupport}
          />
          <Button disabled={!visible} secondary type="button" title="Voltar ao início" onClick={goToHome} />
        </>
      }
    />
  );
};
